import { createReducer, isBusy } from 'actionware';
import { createState } from 'stateware';
import { submitResetPassword, checkToken } from './resetPasswordAction';

const initialState = createState({
  newPassword: null,
  showingInvalidLink: null,
  showingSuccessReset: null
});

export default createReducer(initialState)
  .on(submitResetPassword, (state, newPassword) => {
    return initialState.copy({
      newPassword,
      showingSuccessReset: true
    })
  })

  .on(checkToken, (state, userId) => {
    return initialState.copy({
      userId,
      showingInvalidLink: false,
      showingSuccessReset: false,
      showingResetForm: true
    })
  })

  .onError(submitResetPassword, (state, error) => {
    return initialState.copy({
      showingSuccessReset: false
    })
  })

  .onError(checkToken, (state, error) => {
    return initialState.copy({
      showingInvalidLink: true,
      showingResetForm: false
    })
  })